"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var CollectionClaims_1 = require("../components/CollectionClaims/CollectionClaims");
var targetNode = document.querySelector('.collection-claims');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(CollectionClaims_1.default, null), targetNode);
}
